<svg width="140" height="90" viewBox="0 0 140 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="139" height="88.7739" rx="3.5" fill="currentColor" stroke="#BBBFC3"/>
    <rect x="33" y="12.1044" width="74" height="45.3913" rx="2" fill="#BBBFC3"/>
    <rect x="4" y="66" width="18" height="14" rx="2" fill="#BBBFC3"/>
    <rect x="23" y="66" width="18" height="14" rx="2" fill="#BBBFC3"/>
    <rect x="42" y="66" width="17" height="14" rx="2" fill="#BBBFC3"/>
    <rect x="61" y="66" width="17" height="14" rx="2" fill="#BBBFC3"/>
    <rect x="80" y="66" width="18" height="14" rx="2" fill="#BBBFC3"/>
    <rect x="99" y="66" width="18" height="14" rx="2" fill="#BBBFC3"/>
    <rect x="118" y="66" width="18" height="14" rx="2" fill="#BBBFC3"/>
</svg>
